import React from 'react';

import { importFromS3 } from '../../utils/importFromS3';
import { Operation } from '../../hooks/useOperations/types';

interface DataHubPluginProps {
  operationsSelected: Operation[];
  shouldRenderFarmerNav: boolean;
}

// Runtime dependency
const DataHubPlugin: React.FC<DataHubPluginProps> = React.lazy(() => importFromS3('tcc-data-hub'));

export const DataHubPluginContainer: React.FC<{ operationsSelected: Operation[] }> = ({ operationsSelected }) => (
  <DataHubPlugin
    operationsSelected={operationsSelected}
    shouldRenderFarmerNav={false}
  />
);
